<template>
  <az-container>
    <az-form>
      <div class="li-tabela">
        <v-data-table
            :headers="colunas"
            :items="itens"
            :server-items-length="totalItems"
            :items-per-page="itemsPerPage"
            :page.sync="currentPage"
            @update:page="mudarPagina"
            no-data-text="Nenhum usuário encontrado"
            class="az-table-list tabela-usuarios"
        >
          <template slot="items" slot-scope="props">
            <td>{{ props.item.usuario.nome }}</td>
            <td>{{ props.item.usuario.email }}</td>
            <td class="az-comissoes">
              <v-chip v-for="(comissao, index) in props.item.comissoes" :key="index">
                {{ comissao.comissaoDescricao }}: {{ comissao.usuarioComissaoCargo }}
              </v-chip>
            </td>
            <td>{{ props.item.usuario.situacao }}</td>
            <td class="table-actions">
              <v-tooltip top class="no-mobile" v-az-auth="'Usuario.Visualizar'">
                <template v-slot:activator="{ on }">
                  <a v-on="on" @click="$emit('visualizar', props.item.usuario.id)">
                    <v-icon>search</v-icon>
                  </a>
                </template>
                Visualizar
              </v-tooltip>
            </td>
          </template>
        </v-data-table>
      </div>
    </az-form>
  </az-container>
</template>

<script>
export default {
  name: 'UsuarioBuscaTabela',
  props: ['itens', 'totalItems', 'itemsPerPage', 'currentPage'],
  data() {
    return {
      colunas: [
        { text: 'Usuário', align: 'left', sortable: false, width: '20%' },
        { text: 'E-mail', align: 'left', sortable: false, width: '25%' },
        { text: 'Comissões', sortable: false, align: 'left', width: '35%' },
        { text: 'Situação', sortable: false, align: 'left', width: '10%' },
        { text: 'Ações', align: 'right', sortable: false }
      ]
    }
  },
  methods: {
    mudarPagina(novaPagina) {
      this.$emit('pagina-mudou', novaPagina)
    }
  }
}
</script>

<style lang="stylus">
    @media (max-width: 720px)
        .tabela-usuarios
            td:nth-of-type(1):before
                content: "Usuário:"

            td:nth-of-type(2):before
                content: "E-mail:"

            td:nth-of-type(3)
                span
                    width 100%

            td:nth-of-type(3):before
                content: "Comissões:"

            td:nth-of-type(4):before
                content: "Situação:"

            .table-actions
                display none !important

</style>
